<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OtxGla/tc-custom/9781473852242.jpg?1702845316709" alt="This image is the cover for the book Dunkirk Perimeter and Evacuation 1940, Battleground Dunkirk"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dunkirk Perimeter and Evacuation 1940, Battleground Dunkirk
      </h1>
      <p class="bookDescription body article font2">
        <b>The history of a disastrous WWII setback, including numerous photos, maps, and information for visitors.</b><br/>  <br/> This book tells the story of the fierce fighting around the Dunkirk Perimeter during May and June 1940 between the retreating British Expeditionary Force and its French allies and the advancing German army. This grievous military setback was soon transformed into a morale-boosting symbol of the resilience of the British against a Germany that had crushed so many nations in a matter of weeks.<br/>  <br/> With over 200 black and white photographs and fourteen maps, this book looks at the units deployed around Dunkirk and Nieuport and their often desperate actions to prevent the inevitable advance of German forces opposing them. The evacuation of the BEF from the beaches east of Dunkirk is covered in detail from the perspective of the Royal Navy and from the standpoint of the soldier on the beaches.<br/>  <br/> Also included are details for travelers to the sites involved. In addition to visits to the relevant cemeteries, the book includes three appendices and two car tours, one tour covering the whole of the Dunkirk perimeter and the other covering Ramsgate and Dover, although there is plenty of scope for walking in both tours. There is also a walk around De Panne, which takes the tourist along the beach that saw so much of the evacuation, and into the back areas of the town where the Germans left their mark when clearing up after the British had gone.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jerry Murland
      </h2>
      
      <p class="authorDescription body article">Jerry Murland is a retired headteacher who has written over twenty books and guidebooks coverering the events of the First and Second World Wars. His first book, Aristocrats Go To War, was published by Pen and Sword in 2010 and since then he has gone on the write a number of others, including the Battlelines Guidebooks to the Western Front, co-written with Jon Cooksey. He is currently writing an account of the Battle of the Ypres-Comines Canal 1940, part of eight Battleground Europe books which cover the France and Flanders campaign of 1940.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword/Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?66b616f8